import script from "./tile-band.vue?vue&type=script&lang=js"
export * from "./tile-band.vue?vue&type=script&lang=js"

import "./tile-band.vue?vue&type=style&index=0&id=517339f5&lang=scss"

const __exports__ = script;

export default __exports__